import { Tile, TileSection } from 'foundations-components/transitional/components/Tile';
import NoteLines from '../common/NoteLines';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ApprovalUnifiedEventNote(props) {
  const {
    event
  } = props;
  if (!event.properties.hs_note || !event.properties.hs_note.value) {
    return null;
  }
  return /*#__PURE__*/_jsx(Tile, {
    compact: true,
    marginBlockStart: "200",
    children: /*#__PURE__*/_jsx(TileSection, {
      children: /*#__PURE__*/_jsx(NoteLines, {
        note: event.properties.hs_note.value
      })
    })
  });
}